import React, { useState } from "react";
import { faAngleDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import "./ItemSwitchDropdown.scss";
import { faListOl } from "@fortawesome/pro-regular-svg-icons";
import { HasID } from "userful-chronos-app-common-js/dist/models/common";
import { ConfirmationDialog } from "../../widgets";
import { IUButton } from "../Buttons/buttonsUtils";

interface HasIDAndName extends HasID {
    name: string;
}

interface IProps {
    item: HasIDAndName;
    allItems: HasIDAndName[];
    onClick: (value: string) => void;
    leaveTitle: string;
    leaveDescription: string;
    allowFreeSwitch?: boolean;
    onClose?: Function;
}

export default function ItemSwitchDropdown(props: IProps) {
    const [itemID, setItemID] = useState<string>(null);
    const [show, setShow] = useState<boolean>(false);

    const onLeave = () => {
        props.onClick(itemID);
    };

    const leaveButton: IUButton = { title: "Shared.leave", hideOverlay: true, onClick: onLeave, variant: "ERROR" };
    const cancelButton: IUButton = { title: "Shared.cancel", hideOverlay: true, variant: "SECONDARY" };

    return (
        <>
            <ConfirmationDialog
                type={"WARNING"}
                title={props.leaveTitle}
                description={props.leaveDescription}
                trigger={{
                    value: show,
                    onClose: () => {
                        setShow(false);
                    },
                }}
                buttons={[leaveButton, cancelButton]}
            />
            <Dropdown className="staticDropdown">
                <Dropdown.Toggle bsPrefix="dropdownButtonSwitch" id="dropdownToggle">
                    <div className="textInside">{props.item.name}</div>
                    <FontAwesomeIcon icon={faAngleDown} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdownMenuSwitch">
                    {props.allItems.length > 1 && (
                        <>
                            {props.allItems.map((selected) => {
                                return (
                                    <Dropdown.Item
                                        key={selected.id.value}
                                        className="dropdownItem"
                                        onClick={() => {
                                            if (selected.id.value === props.item.id.value) {
                                            } else if (props.allowFreeSwitch) {
                                                props.onClick(selected.id.value);
                                            } else {
                                                setItemID(selected.id.value);
                                                setShow(true);
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faListOl} />
                                        <div className="textInside">{selected.name}</div>
                                    </Dropdown.Item>
                                );
                            })}
                        </>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}
